// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { ProjectTypeIdEnum } from 'config/enums'
import { castToFloat } from 'helpers/reduxFormFunctions'
import React from 'react'
import { string } from 'prop-types'
import { useSelector } from 'react-redux'
import { Field } from 'redux-form'
import { LabeledInput } from 'components/Form'
import { trimInputValue } from 'validators/common'

const TextInputWrapper = ({ idRoot, sourceForm }) => {
  const projectTypeId = useSelector(state => state.form[sourceForm].values.projectTypeId)

  return (
    castToFloat(projectTypeId) === ProjectTypeIdEnum.PROTECTION
      ? (
        <Field
          autoFocus={true}
          className={'show-error-on-focus'}
          component={LabeledInput}
          id={`${idRoot}-rcn`}
          label={'RCN'}
          name={'rcnNumber'}
          onBlurCustom={trimInputValue}
          placeholder={''} />
      ) : (
        <Field
          autoFocus={true}
          className={'show-error-on-focus'}
          component={LabeledInput}
          id={`${idRoot}-projectName`}
          label={'Project Name'}
          name={'projectName'}
          onBlurCustom={trimInputValue}
          placeholder={''} />
      )
  )
}

TextInputWrapper.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}
export default TextInputWrapper
